// filepath: src/components/MainSection.js
import React from 'react';
import bankingImg from '../assets/img/SELFSALESASSIST$Images$Login_image_3.png';
import storeLogo from '../assets/img/store_logo.svg';
import LoginForm from './LoginForm';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/style.css';

const MainSection = () => {
  return (
    <section>
      <div className="sale_assist_sec">
        <div className="login_field">
          <LoginForm />
        </div>
        <div className="login_img_sec">
          <div className="login_icon">
            <img src={bankingImg} alt="Banking" />
            <div className="finance_heading">
              <h3>Payments and Collections Solution<br />at your fingertips!</h3>
              <div className="app_banking">
                {/* <p>For IndusInd Banking App</p>
                <img src={storeLogo} alt="Store Logo" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainSection;